define('main',[
    'score_ccf/ModuleLoader',
    'scorebootstrap',
    'Frontend',
    'IEBugFixes',
    'Accordions',
    'Header',
    'Footer',
    'Search',
    'ScrollBarWidth',
    'SliderPanel',
    'VerticalSlider',
    'StickyNav',
    'AnimatedBackground',
    'ANSI/UIComponents/Tabsets',
    'ANSI/UIComponents/Popovers',
    'ANSI/UIComponents/ReadMore',
    'ANSI/UIComponents/Buttons',
    'ANSI/Utility/EllipsisMaker',
    'promise-polyfill',
    'jqueryMigrate'
], function (moduleLoader, scorebootstrap, frontend) {
    'use strict';

    /**************************************************************************************************************
         Do not add misc code here only use main.js to initialize modules, all misc code that is global
         can be added to front-end.js, preload will init before all ux modules load and postload after all pending
         modules load. Otherwise please make new js module.
         **************************************************************************************************************/

    // init SCORE Bootstrap components (Tabsets, Accordeons, Carousels, etc.)

    scorebootstrap.init();
    Promise.resolve().then(frontend.preload);
    Promise.resolve().then(frontend.postload);

    moduleLoader.loadPendingModules().done(function () {
        try {
            window.ANSILoadGTM();
        } catch (e) {
            console.log("window.ANSILoadGTM() was not found.");
        }
    });

});

